import Notifications from '../../../api/notifications/notifications';
import fileDownload from "js-file-download";
import router from "@/router";

const notifications = new Notifications();

const notificationsModule = {

  namespaced: true,
  state: {
    items: [],
    test: 'TTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT',
    load: false
  },
  getters: {
    items(state) {
      return state.items;
    },
    load(state) {
      return state.load;
    },
  },
  mutations: {
    SET_ITEMS: (state, modules) => {
      state.items = modules;
    },
    SET_ITEMS_LOAD: (state, load) => {
      state.load = load;
    },
  },
  actions: {
    list({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        notifications.list(payload).then(response => {          
          commit('SET_ITEMS', response);
          commit('SET_ITEMS_LOAD', false);
          resolve();
        });
      });
    },
    markAllAsRead({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        notifications.markAllAsRead().then(response => {          
          commit('SET_ITEMS_LOAD', false);
          resolve();
        });
      });
    },
    markAsRead({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_ITEMS_LOAD', true);
        notifications.markAsRead(payload).then(response => {          
          commit('SET_ITEMS_LOAD', false);
          resolve();
        });
      });
    },
  }
}

export default notificationsModule;
